import { InventoryType } from '@scaleaq/sitecontrol-lib';

import type { DeviceSummary } from '@/types';
import { labelForDeviceType } from '@/utils/deviceTypeLabel.ts';

export const getFormattedDeviceType = (key: string | undefined) => {
  const labeled = labelForDeviceType(key);
  if (key && labeled !== key) return labeled;

  const removeStrings = ['Analogue', 'Digital', 'Analog', 'Input', 'Output'];

  const remove_rgex = new RegExp(removeStrings.join('|'), 'g'); // Create regex pattern
  const strippedKey = key?.replace(remove_rgex, ''); // Replace all occurrences

  return strippedKey
    ? strippedKey.split(/(?<=[a-z0-9])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/).join(' ')
    : '';
};

/** GIO channels prefer formatted subtype, otherwise formatted inventory type (cards, info modals). */
export const typeLabelForDevice = (device: DeviceSummary): string => {
  if (device.type === InventoryType.GioChannel && 'channelSubtype' in device) {
    const { channelSubtype } = device;
    if (channelSubtype != null) {
      const fromSubtype = getFormattedDeviceType(String(channelSubtype));
      if (fromSubtype !== '') {
        return fromSubtype;
      }
    }
  }
  return getFormattedDeviceType(String(device.type));
};
